// extracted by mini-css-extract-plugin
export default {"rootLayout":"TextWithIconCards_rootLayout__3uX+-","heading":"TextWithIconCards_heading__FY7qB","cards":"TextWithIconCards_cards__kB7gb"};